export function CheckedOption({ ...rest }) {
  return (
    <svg
      {...rest}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="9" fill="#54A6AA" />
      <path
        d="M7.3 12.8601C7.21449 12.8601 7.13297 12.8443 7.05543 12.8127C6.9779 12.781 6.90507 12.7312 6.83695 12.663L3.82028 9.64637C3.68888 9.51497 3.62318 9.35507 3.62318 9.16666C3.62318 8.97825 3.68888 8.81834 3.82028 8.68694C3.95168 8.55554 4.10761 8.48984 4.28805 8.48984C4.46848 8.48984 4.62754 8.55554 4.76522 8.68694L7.3 11.2217L13.2275 5.30361C13.3589 5.17221 13.5161 5.10493 13.6989 5.10179C13.8818 5.09866 14.0389 5.16593 14.1703 5.30361C14.3017 5.43501 14.3674 5.59371 14.3674 5.77971C14.3674 5.9657 14.3017 6.12439 14.1703 6.25579L7.76305 12.663C7.69493 12.7312 7.6221 12.781 7.54457 12.8127C7.46703 12.8443 7.38551 12.8601 7.3 12.8601Z"
        fill="white"
      />
    </svg>
  );
}
